import React from "react";
import { parseDescriptionText, formatUpgradeText } from "lib/general-helper";

interface UpgradeTooltipProps {
  tier: 1 | 2 | 3;
  t1Desc: string;
  t2Desc: string;
  t3Desc: string;
  upgrades: Record<number, Record<string, string | number>>;
}

const UpgradeTooltip = (props: UpgradeTooltipProps) => {
  const { tier, t1Desc, t2Desc, t3Desc, upgrades } = props;

  // Determine which description to use based on the tier
  let description = "";
  let boltIcon = "https://static.bigbrain.gg/deadlock/image-assets/white-bolt.png";

  if (tier === 1) {
    description = t1Desc || formatUpgradeText(upgrades[0]);
  } else if (tier === 2) {
    description = t2Desc || formatUpgradeText(upgrades[1]);
  } else if (tier === 3) {
    description = t3Desc || formatUpgradeText(upgrades[2]);
    // Tier 3 uses a blue bolt icon
    boltIcon = "https://static.bigbrain.gg/deadlock/image-assets/blue-bolt.png";
  }

  // Parse HTML tags in the description
  const parsedDescription = parseDescriptionText(description);

  return (
    <div className="tooltip-content ability-upgrade">
      <div className="flex-wrapper">
        <div className="bolt-image">
          <img src={boltIcon} alt={`Tier ${tier} Bolt`} />
        </div>
        <p className="tier-description" dangerouslySetInnerHTML={{ __html: parsedDescription }} />
      </div>
    </div>
  );
};

export default UpgradeTooltip;
